(function () {
  if (window.lfFaqReady) return;
  window.lfFaqReady = true;

  function reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function openGroup(hash, scroll) {
    if (!hash || hash.length < 2) return;
    var id;
    try {
      id = decodeURIComponent(hash.slice(1));
    } catch (e) {
      return;
    }
    var title = document.getElementById(id);
    if (!title || !title.classList.contains('lf-faq__group-title')) return;
    var item = title.nextElementSibling;
    var details = item && item.classList.contains('lf-faq__item') ? item.querySelector('details') : null;
    if (!details) return;
    details.setAttribute('open', '');
    var summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'true');
    if (scroll) {
      title.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'start' });
    }
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href*="#"]');
    if (!link) return;
    var url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (e) {
      return;
    }
    if (url.pathname !== window.location.pathname || url.origin !== window.location.origin) return;
    openGroup(url.hash, link.getAttribute('href').charAt(0) === '#' && url.hash === window.location.hash);
  });

  window.addEventListener('hashchange', function () {
    openGroup(window.location.hash, false);
  });

  openGroup(window.location.hash, false);
})();
